import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./LibraryLessonCardDifficulty.module.scss";
import {isDefined, isUndefined} from "../../../util/is-type";

export interface ILibraryLessonCardDifficultyProps {
  name?: string;
  useClassName?: string;
}

export const LibraryLessonCardDifficulty: VoidFunctionComponent<ILibraryLessonCardDifficultyProps> = ({name, useClassName}) => {

  if (isUndefined<string>(name)){
    // don't have difficulty name, nothing to return
    return null;
  }

  const classNames: string[] = [
    s.difficulty
  ];
  if (isDefined<string>(useClassName)){
    classNames.push(useClassName);
  }
  return <div className={classNames.join(` `)} dangerouslySetInnerHTML={{__html: name}}></div>;
}



